import { JSX } from "react";

import FooterLinks from "@/components/layout/Footer/FooterLinks.tsx";
import FooterMenus from "@/components/layout/Footer/FooterMenus.tsx";

import MobileFooter from "./MobileFooter";

const Footer = (): JSX.Element => {
  return (
    <>
      <footer className={"flex justify-center max-md:hidden"}>
        <div
          className={
            "flex w-full flex-col gap-16 px-6 pb-[3.5rem] pt-12 max-2xl:px-5 max-lg:gap-8 max-lg:px-4   max-lg:pb-6 max-lg:pt-10 max-lg:text-start"
          }
        >
          <FooterMenus />
          <FooterLinks />
        </div>
      </footer>
      <MobileFooter />
    </>
  );
};

export default Footer;
